import { render } from "./ThankYouPopUp.vue?vue&type=template&id=646ba819&scoped=true"
import script from "./ThankYouPopUp.vue?vue&type=script&lang=js"
export * from "./ThankYouPopUp.vue?vue&type=script&lang=js"

import "./ThankYouPopUp.vue?vue&type=style&index=0&id=646ba819&lang=scss"
import "./ThankYouPopUp.vue?vue&type=style&index=1&id=646ba819&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646ba819"]])

export default __exports__